export const ENABLE_ONEDATA_READ_MERCHANTS = true;
export const ENABLE_ONEDATA_READ_OFFERS = true;
export const ENABLE_ONEDATA_ENROLL_OFFER = true;
export const ENABLE_ONEDATA_TYPEAHEAD = true;
export const ENABLE_ONEDATA_IB = true;
export const ENABLE_ONEDATA_IMPRESSIONS = true;
export const ENABLE_ONEDATA_FEEDBACK = true; // Merchant Edit Suggestion = Merchant Feedback
